<template>
<div>
  Route assessors are not tied to individual routes within an application but are instead assessed in a blanket fashion across all application routes.

  <select-input
    :value="assessor.assessor_id"
    @input="updateAssessor"
    :items="assessors"
    label-key="name"
    value-key="id">
    Assessor
  </select-input>
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { get } from '@/api/request'

export default {

  data: () => ({
    assessors: []
  }),

  beforeCreate() {
    get('api/super/route-assessment-handlers', ({data}) => {
      this.assessors = data
    })
  },

  methods: {
    ...mapMutations('assessor', [
      'updateAssessor'
    ])
  },

  computed: {
    ...mapGetters('assessor', [
      'assessor'
    ]),
  }
}
</script>